import React from "react";
import SlotsMachine from "./components/pages/SlotsMachine/SlotsMachine";

const App = () => {
    return (
        <div>
            <SlotsMachine />
        </div>
    );
};

export default App;
